import { Serializable } from "./serializable";

export default class Coupon implements Serializable<Coupon> {
  code?: string;
  discountPercent?: string;
  discountCents?: any;
  discountType?: 'percent' | 'absolute';

  deserialize(input: any): Coupon {
    if (input != null) {
      this.code = input.code;
      this.discountPercent = input.discount_percent;
      this.discountCents = input.discount_cents;
      this.discountType = input.discount_type;
    }
    return this;
  }
}
